"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MERCHANT = exports.APP = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _reduxActions = require("redux-actions");

var _ = require("./");

var _helocActions = require("../actions/heloc-actions");

var _wsActions = require("../actions/ws-actions");

var _env = require("../env");

var CONTEXT = _env.isMerchant ? '/app-merloc/ws/secure' : '/service-application/ws';

var socketUrl = function socketUrl() {
  return "".concat((0, _wsActions.baseUrl)()).concat(CONTEXT, "/api/v1/application");
};

var socketPredicate = function socketPredicate(action) {
  return action.type === _helocActions.ACTIVATE_HELOC;
};

var jwtOrNull = function jwtOrNull(store) {
  var identity = store.getState().identityReducer || {};
  return (identity.jwt || '').replace('Bearer ', '') || null;
};

var APP = 'APP';
exports.APP = APP;
var MERCHANT = 'MERCHANT';
exports.MERCHANT = MERCHANT;
var APP_SOCKET_MESSAGE = _env.isMerchant ? "".concat(MERCHANT, "_").concat(_wsActions.SOCKET_MESSAGE) : "".concat(APP, "_").concat(_wsActions.SOCKET_MESSAGE);
var eventHandlers = {
  onopen: (0, _reduxActions.createAction)("".concat(APP, "_").concat(_wsActions.SOCKET_OPEN)),
  onclose: (0, _reduxActions.createAction)("".concat(APP, "_").concat(_wsActions.SOCKET_CLOSE)),
  onerror: (0, _reduxActions.createAction)("".concat(APP, "_").concat(_wsActions.SOCKET_ERROR)),
  onmessage: (0, _reduxActions.createAction)(APP_SOCKET_MESSAGE, function (e) {
    return (0, _typeof2.default)(e) === 'object' ? e.data : e;
  })
};

var createAppSocketMiddleware = function createAppSocketMiddleware() {
  var sendInterval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
  var reconnect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return (0, _.createSocketMiddleware)(socketUrl(), null, socketPredicate, undefined, eventHandlers, {
    sendInterval: sendInterval,
    reconnect: reconnect,
    protocol: jwtOrNull
  });
};

var _default = createAppSocketMiddleware;
exports.default = _default;